var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['action-bubble', { 'bubble-wrapper': _vm.active }],on:{"click":function($event){return _setup.emit('click', $event)}}},[_vm._t("default"),(_vm.active)?_c('div',{class:[`bubble`, _vm.type]},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }